<template>
  <custom-multi-select-field
      v-if="showComponent && onReady"
      :key="componentRefresh"
      :ref="`ks-custom-multi-select-field-${_uid}`"
      :enableSearch="enableSearch"
      :enableDBSearch="enableDBSearch"
      :open="open"
      :fieldId="fieldId"
      :maxHeight="maxHeight"
      :checkInLine="checkInLine"
      :tooltip="tooltip"
      :tooltipIcon="tooltipIcon"
      :tooltipRight="tooltipRight"
      :tooltipLeft="tooltipLeft"
      :inLine="inLine"
      :classes="classes"
      :label="label"
      :options="options"
      :validation="validation"
      :validationOnChange="validationOnChange"
      :helpText="helpText"
      :required="required"
      :disabled="disabled"
      :readOnly="readOnly"
      :optionValue="optionValue"
      :optionLabel="optionLabel"
      :optionFilter="optionFilter"
      :accordian="accordian"
      :dropdown="dropdown"
      :title="title"
      :placeholder="placeholder"
      :showLimit="showLimit"
      :showNewOption="showNewOption"
      :newOptionLabel="newOptionLabel"
      :showNullOption="showNullOption"
      :nullOptionLabel="nullOptionLabel"
      :showSelectedOnClose="showSelectedOnClose"
      :sortOptionsBySelected="sortOptionsBySelected"
      v-model="input"
      @onMounted="selectorMounted"
      @onClick="onClick"
      @onChange="onChange"
      @onOpened="onOpened"
      @onClosed="onClosed"
      @onFocus="onFocus"
      @onBlur="onBlur"
      @onKeypress="onKeyPress"
      @onNewClick="onNewClick"
  />
</template>

<script>
import Vuex from 'vuex';
import checkPermissions from '../../../mixins/checkPermissions';
import dataproviderOptionsValidation from './../mixins/index.js';
import custom_multi_select_field from './../selector-types/custom-multi-select-field';

export default {
  /**
   tag
   name: ks-multi-selector
   description: ks-multi-selector
   **/
  name: "ks-multi-selector",
  mixins: [checkPermissions, dataproviderOptionsValidation],
  components: {
    'custom-multi-select-field': custom_multi_select_field
  },
  props: {
    /**
     attribute
     name: dataSource
     description: dataSource
     **/
    title: {
      type: String,
      default: null
    },
    dropdown: {
      type: Boolean,
      default: false
    },
    showLimit: {
      type: Number,
      default: 2
    },
    placeholder: {
      type: String,
      default: null
    },
    dataSource: {
      type: String,
      required: true
    },
    /**
     attribute
     name: defaultValue
     description: defaultValue
     **/
    defaultValue: {},
    /**
     attribute
     name: enableSearch
     description: enableSearch
     **/
    enableSearch: {
      type: Boolean,
      default: true
    },
    /**
     attribute
     name: enableDBSearch
     description: enableDBSearch
     **/
    enableDBSearch: {
      type: Boolean,
      default: false
    },
    /**
     attribute
     name: open
     description: open
     **/
    open: {
      type: Boolean,
      default: false
    },
    /**
     attribute
     name: fieldId
     description: fieldId
     **/
    fieldId: {
      type: String,
      default: null
    },
    /**
     attribute
     name: maxHeight
     description: maxHeight
     **/
    maxHeight: {
      type: String,
      default: "650px"
    },
    /**
     attribute
     name: checkInLine
     description: checkInLine
     **/
    checkInLine: {
      type: Boolean,
      default: false
    },
    /**
     attribute
     name: tooltip
     description: tooltip
     **/
    tooltip: {
      type: String,
      default: null
    },
    /**
     attribute
     name: tooltipIcon
     description: tooltipIcon
     **/
    tooltipIcon: {
      type: String,
      default: 'fas fa-question-circle'
    },
    /**
     attribute
     name: tooltipRight
     description: tooltipRight
     **/
    tooltipRight: {
      type: Boolean,
      default: false
    },
    /**
     attribute
     name: tooltipLeft
     description: tooltipLeft
     **/
    tooltipLeft: {
      type: Boolean,
      default: true
    },
    /**
     attribute
     name: inLine
     description: inLine
     **/
    inLine: {
      type: Boolean,
      default: false
    },
    /**
     attribute
     name: classes
     description: classes
     **/
    classes: {
      type: String,
      required: false
    },
    /**
     attribute
     name: label
     description: label
     **/
    label: {
      type: String,
      default: null
    },
    /**
     attribute
     name: options
     description: options
     **/
    options: {
      default: () => []
    },
    /**
     attribute
     name: validation
     description: validation
     **/
    validation: {
      type: Function,
      default: null
    },
    /**
     attribute
     name: validationOnChange
     description: validationOnChange
     **/
    validationOnChange: {
      type: Boolean,
      default: false
    },
    /**
     attribute
     name: helpText
     description: helpText
     **/
    helpText: {
      type: String,
      default: null
    },
    /**
     attribute
     name: required
     description: required
     **/
    required: {
      type: Boolean,
      default: false
    },
    /**
     attribute
     name: disabled
     description: disabled
     **/
    disabled: {
      type: Boolean,
      default: false
    },
    /**
     attribute
     name: readOnly
     description: readOnly
     **/
    readOnly: {
      type: Boolean,
      default: false
    },
    /**
     attribute
     name: optionValue
     description: optionValue
     **/
    optionValue: {
      type: String,
      default: null
    },
    /**
     attribute
     name: optionLabel
     description: optionLabel
     **/
    optionLabel: {
      type: String,
      default: null
    },
    /**
     attribute
     name: optionFilter
     description: optionFilter
     **/
    optionFilter: {
      default: null
    },
    /**
     attribute
     name: accordian
     description: accordian
     **/
    accordian: {
      type: Boolean,
      default: false
    },
    /**
     attribute
     name: showNewOption
     description: showNewOption
     **/
    showNewOption: {
      type: Boolean,
      default: false
    },
    /**
     attribute
     name: newOptionLabel
     description: newOptionLabel
     **/
    newOptionLabel: {
      type: String,
      default: "New"
    },
    /**
     attribute
     name: showNullOption
     description: showNullOption
     **/
    showNullOption: {
      type: Boolean,
      default: false
    },
    /**
     attribute
     name: nullOptionLabel
     description: nullOptionLabel
     **/
    nullOptionLabel: {
      type: String,
      default: "None"
    },
    /**
     attribute
     name: showSelectedOnClose
     description: showSelectedOnClose
     **/
    showSelectedOnClose: {
      type: Boolean,
      default: false
    },
    /**
     attribute
     name: returnType
     description: returnType
     **/
    returnType: {
      type: String,
      default: 'csv'
    },
    /**
     attribute
     name: sortOptionsBySelected
     description: sortOptionsBySelected
     **/
    sortOptionsBySelected: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    input: function (val, oldVal) {
      //enable for testing
    },
    defaultValue: function (val) {
      this.input = val;
    }
  },
  computed: {
    ...Vuex.mapGetters({auth: 'rms_ui/auth/auth'}),
    inputType() {
      return this.$parent.type;
    },
    input: {
      get() {
        if (this.returnType !== "array") {
          if (this.inputType === 'list') {
            return this.$parent.data_provider_ref[this.inputType][this.index][this.dataSource] ? this.$parent.data_provider_ref[this.inputType][this.index][this.dataSource].split(',') : [];
          } else {
            return this.$parent.data_provider_ref[this.inputType][this.dataSource] ?
                typeof this.$parent.data_provider_ref[this.inputType][this.dataSource] === 'string' ?
                    this.$parent.data_provider_ref[this.inputType][this.dataSource].split(',') : [this.$parent.data_provider_ref[this.inputType][this.dataSource]] : [];
          }
        } else {
          if (this.inputType === 'list') {
            return this.$parent.data_provider_ref[this.inputType][this.index][this.dataSource];
          } else {
            return this.$parent.data_provider_ref[this.inputType][this.dataSource];
          }
        }
      },
      set(newval) {
        if (this.returnType !== "array") {
          let aux = typeof newval == 'string' ? newval : Array.isArray(newval) ? newval.join(',') : null;
          if (this.inputType === 'list') {
            this.$set(this.$parent.data_provider_ref[this.inputType][this.index], this.dataSource, newval.length ? aux : null);
          } else {
            this.$set(this.$parent.data_provider_ref[this.inputType], this.dataSource, newval.length ? aux : null);
          }
        } else {
          if (this.inputType === 'list') {
            this.$set(this.$parent.data_provider_ref[this.inputType][this.index], this.dataSource, newval);
          } else {
            this.$set(this.$parent.data_provider_ref[this.inputType], this.dataSource, newval);
          }
        }
      }
    }
  },
  methods: {
    validate_input() {
      return this.$refs[`ks-custom-multi-select-field-${this._uid}`]?.validate_input();
    },
    selectorMounted(evt) {
      setTimeout(() => {
        if (typeof this.defaultValue !== 'undefined') {
          this.input = this.defaultValue;
        }
        this.$parent.data_provider_ref.inputs[this.dataSource] = this;
        this.$emit('onMounted', this);
      }, 100)
    },
    onKeyPress(evt) {
      this.$emit('onKeyPress', this);
    },
    onBlur(evt) {
      this.$emit('onBlur', this);
    },
    onFocus(evt) {
      this.$emit('onFocus', this);
    },
    onClick(evt) {
      this.$emit('onClick', this);
    },
    onChange(evt) {
      this.$emit('onChange', this);
    },
    onNewClick(evt) {
      this.$emit('onNewClick', this);
    },
    onOpened(evt) {
      this.$emit('onOpened', evt);
    },
    onClosed(evt) {
      this.$emit('onClosed', evt);
    }
  },
  data() {
    return {
      test: []
    }
  }
}
</script>
